// utils/localization.js - Indian localization utilities

// Format currency in Indian Rupees with Indian Number System
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Math.abs(amount));
};

// Format date in Indian format (DD/MM/YYYY)
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

// Format date in long format for headers
export const formatLongDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Format number in Indian Number System (e.g., 1,00,00.00)
export const formatNumber = (number) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
};

// Convert USD to INR (you might want to update this with real-time exchange rates)
export const convertUsdToInr = (usdAmount, exchangeRate = 83.5) => {
  return usdAmount * exchangeRate;
};
